"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.completeTaskSwaggerMetadata = exports.getTasksSwaggerMetadata = exports.deleteTaskSwaggerMetadata = exports.getTaskByIdSwaggerMetadata = exports.updateTaskSwaggerMetadata = exports.createTaskSwaggerMetadata = void 0;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const create_task_dto_1 = require("./dto/create-task.dto");
const update_task_dto_1 = require("./dto/update-task.dto");
const task_response_dto_1 = require("./dto/task-response.dto");
const get_task_dto_1 = require("./dto/get-task.dto");
const createTaskSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_task_dto_1.CreateTaskDto), (0, swagger_1.ApiOperation)({
        summary: "Create a new task",
        description: "Create a new task",
    }), (0, swagger_1.ApiBody)({
        description: "Task data",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_task_dto_1.CreateTaskDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: messages_1.successMessage.taskCreation,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: { type: "string", example: messages_1.successMessage.taskCreation },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.taskCreationFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.taskCreationFailed,
                },
            },
        },
    }));
};
exports.createTaskSwaggerMetadata = createTaskSwaggerMetadata;
const updateTaskSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(update_task_dto_1.UpdateTaskDto), (0, swagger_1.ApiOperation)({
        summary: "Update a task",
        description: "Update a task",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Task ID",
        type: Number,
    }), (0, swagger_1.ApiBody)({
        description: "Task data",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(update_task_dto_1.UpdateTaskDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.taskUpdation,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.taskUpdation },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.taskUpdateFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.taskUpdateFailed,
                },
            },
        },
    }));
};
exports.updateTaskSwaggerMetadata = updateTaskSwaggerMetadata;
const getTaskByIdSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(task_response_dto_1.TaskDto), (0, swagger_1.ApiOperation)({
        summary: "Get task by ID",
        description: "Get task by ID",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Task ID",
        type: Number,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.taskDetails,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.taskDetails },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(task_response_dto_1.TaskDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.taskNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.taskNotFound },
            },
        },
    }));
};
exports.getTaskByIdSwaggerMetadata = getTaskByIdSwaggerMetadata;
const deleteTaskSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Delete a task",
        description: "Delete a task",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Task ID",
        type: Number,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.taskDeleted,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.taskDeleted },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.taskNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.taskNotFound },
            },
        },
    }));
};
exports.deleteTaskSwaggerMetadata = deleteTaskSwaggerMetadata;
const getTasksSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Get all tasks",
        description: "Get all tasks",
    }), ...Object.keys(get_task_dto_1.GetTasksDto.prototype).map((key) => (0, swagger_1.ApiQuery)({
        name: key,
        required: false,
        description: Reflect.getMetadata("swagger/apiModelProperties", get_task_dto_1.GetTasksDto.prototype, key)?.description,
        example: Reflect.getMetadata("swagger/apiModelProperties", get_task_dto_1.GetTasksDto.prototype, key)?.example,
    })), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.taskList,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.taskList },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                $ref: (0, swagger_1.getSchemaPath)(task_response_dto_1.TaskDto),
                            },
                        },
                        count: { type: "number", example: 10 },
                    },
                },
            },
        },
    }));
};
exports.getTasksSwaggerMetadata = getTasksSwaggerMetadata;
const completeTaskSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({ summary: "Mark task as complete" }), (0, swagger_1.ApiParam)({ name: "id", description: "Task ID", type: Number }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.taskCompleted,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.taskCompleted },
                data: {
                    type: "object",
                    properties: { id: { type: "number", example: 1 } },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.taskCompletionFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: messages_1.errorMessages.taskCompletionFailed },
            },
        },
    }));
};
exports.completeTaskSwaggerMetadata = completeTaskSwaggerMetadata;
